const DS_TOKEN_PREFIX = '--ds';
const DS_FALLBACK_TOKEN_PREFIX = '--ds-fb';

const cssVar = (value: string, fallback?: string): `var(${string})` => {
  if (!value) {
    throw new Error('Invalid value provided!');
  }

  if (fallback) {
    return `var(${value}, ${fallback})` as const;
  }

  return `var(${value})` as const;
};

const cssDsTokenVar = (dsToken: string): `var(${string})` => {
  if (!dsToken || !dsToken.startsWith(DS_TOKEN_PREFIX)) {
    throw new Error('Invalid token provided!');
  }

  const dsFallbackToken = `${DS_FALLBACK_TOKEN_PREFIX}${dsToken.substring(
    DS_TOKEN_PREFIX.length
  )}`;

  return cssVar(dsToken, cssVar(dsFallbackToken));
};

const TokenToHexMap = {
  '--ds-background-accent-red-subtle': '#AB504B',
  '--ds-background-accent-yellow-subtle': '#A98F3A',
  '--ds-background-accent-green-subtle': '#358E69',
  '--ds-background-accent-blue-subtle': '#3E6CAF',
  '--ds-background-accent-gray-subtler': '#989B9E',
  '--ds-background-accent-magenta-subtle': '#9F5281',
  '--ds-background-accent-teal-subtle': '#4C869A',
  '--ds-background-accent-purple-subtle': '#6E63A4',
  '--ds-background-accent-orange-subtle': '#AF7248',
  '--ds-background-accent-gray-subtle': '#5C6470',
  '--ds-background-accent-lime-subtle': '#678A37',
};

const getTokenHexValue = (token: string): string => {
  return TokenToHexMap[token];
};

const cssUnit = (value: string | number): string => {
  if (
    value === undefined ||
    value === null ||
    (typeof value === 'string' && value.trim() === '')
  ) {
    throw new Error('Invalid value provided!');
  }

  if (typeof value === 'number') {
    return `${value}px`;
  }

  return value;
};

export const CssUtils = { getTokenHexValue, cssVar, cssDsTokenVar, cssUnit };
